<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>积分流水管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input
            placeholder="请输入家长姓名"
            v-model="queryInfo.name"
            clearable
            @clear="getList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="请输入学生姓名"
            v-model="queryInfo.s_name"
            clearable
            @clear="getList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>

      <!-- 列表区域 -->
      <el-table :data="userlist" border stripe style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column
          label="单号"
          prop="id"
          width="60px"
          align="center"
        ></el-table-column>
        
        <el-table-column
          label="家长姓名"
          prop="name"
          width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="学生姓名"
          prop="s_name"
          width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="说明"
          prop="title"
          width="150px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="类型"
          prop="typeStr"
          width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="积分数"
          prop="count"
          align="center"
          width="60px"
        ></el-table-column>
        <!-- <el-table-column
          label="类型"
          prop="type"
          align="center"
          width="80px"
        ></el-table-column> -->

        <el-table-column
          label="时间"
          align="center"
          prop="create_at"
          width="140px"
        ></el-table-column>

        <el-table-column label="状态" align="center" width="80px">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == '0'"
              >减少</el-tag
            >
            <el-tag class="success" v-if="scope.row.status == '1'"
              >增加</el-tag
            > 
          </template>
        </el-table-column>
       
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canLook: 1,
      // 获取列表的参数对象
      queryInfo: {
        name: "",
        s_name: "",
        id: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },
      userlist: [],
      total: 0,
    
    };
  },

  created() {
    this.getList();
  },

  methods: {
    

    //搜索
    search() {
      this.filterSelect();
    },

    filterSelect() {
      this.total = 0;
      this.queryInfo.pagenum = 1;
      this.userlist = [];
      this.getList();
    },

    async getList() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get(
        "admin/users/getJifenList",
        {
          params: this.queryInfo,
        }
      );
      if (res.code !== 200) {
        return this.$message.error("暂无积分信息！");
      }
      this.userlist = res.result.list;
      this.total = res.result.count;
      this.list = [];
      console.log(this.userlist);
    },

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getList();
    },

    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },

  },
};
</script>

<style lang="less" scoped>
.danger {
  background-color: rgb(237, 94, 94);
  color: white;
}
</style>
